/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { task } from 'ember-concurrency';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import ApiService from 'cio/services/api';
import { Task } from 'ember-concurrency';
import CampaignModel from 'cio/models/campaign';
import RouterService from '@ember/routing/router-service';
import { campaignBroadcastPath } from 'cio/helpers/campaign-broadcast-path';
import { WorkflowCopyModalActions } from 'cio/utils/analytics/transforms/campaign';
import EnvironmentService from 'cio/services/environment';

interface VisualWorkflowBuilderV2CopyToModalArgs {
  campaign: CampaignModel;
  highlightedNodeIds: string[];
  persistCopyTo: Task<unknown[], [any, any[], string]>;
  onClose: () => unknown;
  trackEvent: (modalActionType: WorkflowCopyModalActions) => unknown;
  hasReadOnlyPermission: boolean;
}

export default class VisualWorkflowBuilderV2CopyToModal extends Component<VisualWorkflowBuilderV2CopyToModalArgs> {
  @service api!: ApiService;
  @service router!: RouterService;
  @service environment!: EnvironmentService;

  @tracked selectedEnvironmentId = '';
  @tracked selectedCampaignId = '';

  @tracked campaignToPersist: any = null;
  @tracked actionsToPersist: any[] | null = null;

  get isSameCampaign() {
    return this.args.campaign.id === this.selectedCampaignId;
  }

  @action
  onCopyToFinished(serializedCampaign: any, serializedActions: any[]) {
    this.campaignToPersist = serializedCampaign;
    this.actionsToPersist = serializedActions;
  }

  @tracked openTargetWorkflow = false;

  confirmSave = task({ restartable: true }, async () => {
    await this.args.persistCopyTo.perform(
      this.campaignToPersist,
      this.actionsToPersist as any[],
      this.selectedEnvironmentId,
    );

    this.args.onClose();

    if (this.openTargetWorkflow) {
      let path = `${campaignBroadcastPath([this.campaignToPersist.type])}.workflow`;
      let targetUrl = this.router.urlFor(path, this.selectedEnvironmentId, this.selectedCampaignId);

      window.open(targetUrl);
    }
  });

  @action
  onUndo() {
    this.campaignToPersist = null;
    this.actionsToPersist = null;

    this.args.trackEvent(WorkflowCopyModalActions.PlacementUndo);
  }

  @action
  onSelectEnvironment(environmentId: string) {
    this.selectedEnvironmentId = environmentId;
  }

  @action
  onSelectCampaign(campaignId: string) {
    this.selectedCampaignId = campaignId;
  }
}
